/* eslint-disable */
import axios from "axios";
import { store } from "../store";
import { PATH_APILMS_V2, PATH_APILOG_V2, appSetting } from "../shared/app-settings";
import { setToken, removeToken } from '../store/oauth/oauthSlice';
import { decodeHtmlEntites } from "./utils/decodeHtmlEntites";
import he from 'he';
import Cookies from "js-cookie";
let authTokenRequest = null;
let requestInterceptorId = null; // Lưu ID của interceptor để có thể xóa sau

function refreshToken(refreshToken) {
  let data =
    "grant_type=refresh_token&client_id=" +
    appSetting.CLIENT_ID +
    "&refresh_token=" +
    refreshToken;
  return axios.post("/connect/token", data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}


export default function registerAxiosInterceptor() {
  // Xóa interceptor cũ nếu đã tồn tại để tránh đăng ký nhiều lần
  if (requestInterceptorId !== null) {
    axios.interceptors.request.eject(requestInterceptorId);
    requestInterceptorId = null;
  }

  // Set base URL và default headers
  axios.defaults.baseURL = appSetting.ADMIN_URL;
  
  // Lấy token ban đầu từ store để set default header
  let oauth = store.getState().oauth;
  if (oauth && oauth.access_token) {
    axios.defaults.headers.common['Authorization'] = `${oauth.access_token}`;
  }

  // Đăng ký interceptor mới và lưu ID
  requestInterceptorId = axios.interceptors.request.use(
    function (config) {
      // Lấy oauth mới nhất từ store mỗi lần request để đảm bảo token luôn cập nhật
      const currentOauth = store.getState().oauth;
      if (currentOauth && currentOauth.access_token) {
        config.headers['Authorization'] = `${currentOauth.access_token}`;
      } else {
        // Nếu không có token, xóa Authorization header
        delete config.headers['Authorization'];
      }
  
      let beforeRequest = {
        config: config,
        status: 0,
        data: null
      };
  
      // Ẩn log before request
      // loggerAPI(beforeRequest);
  
      return config;
    },
    function (error) {
      console.log('Có lỗi xảy ra trong interceptor:', error);
      return Promise.reject(error);
    }
  );
 
}

// Export function để xóa interceptor khi cần
export function removeAxiosInterceptor() {
  if (requestInterceptorId !== null) {
    axios.interceptors.request.eject(requestInterceptorId);
    requestInterceptorId = null;
  }
}
